module.exports = __webpack_public_path__ + "img/111.4.876e3d74.png";